import script from "./provident-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./provident-modal.vue?vue&type=script&setup=true&lang=js"

import "./provident-modal.vue?vue&type=style&index=0&id=aec2b934&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aec2b934"]])

export default __exports__